import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SectionsEditorService {
  private selectedSectionId$:BehaviorSubject<string> = new BehaviorSubject<string>(null)

  constructor() { }

  setSelectedId(sectionId:string){
    this.selectedSectionId$.next(sectionId);
  }

  getSelectedSectionId():Observable<string>{
    return this.selectedSectionId$.asObservable()
  }
}
